import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FormGroup, FormControl} from '@angular/forms';

@Component({
    selector: 'app-form-group-input',
    templateUrl: './form-group-input.component.html',
    styleUrls: ['./form-group-input.component.css'],
    standalone: false
})
export class FormGroupInputComponent implements OnInit {

  @Input()
  label: string;

  @Input()
  inputType: string;

  @Input()
  additionalClass: string;

  @Input()
  placeHolder: string;

  @Input()
  model: string;

  @Input()
  disabled = false;

  @Input()
  required = false;

  @Input()
  name: string;

  @Input()
  id: string;

  @Input()
  error: string;

  @Input()
  formControlNameValue: string;

  @Input()
  formGroup: FormGroup;

  @Output()
  modelChange: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  focus: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  public showPassword = false;

  ngOnInit() {
  }

  change() {
    this.modelChange.emit(this.model);
  }

  onChange(event) {
    this.focus.emit(event.target.value);
  }

  toggleVisibility() {
    this.showPassword = !this.showPassword;
  }

}
